export interface GoogleCalendarEventParams {
    title: string;
    sessionNumber?: number;
    sessionTime: number; // epoch ms
    durationHours?: number; // default 3.5 hours
    systemTitle?: string;
    gmName?: string;
    organizerName?: string;
    invitationId?: string;
    online?: boolean;
    onlinePlatform?: string;
    addressGmapsFormatted?: string;
    addressGmapsUrl?: string;
    accessInfo?: string;
}

export function formatUtcForGoogleCalendar(timestamp: number): string {
    return new Date(timestamp).toISOString().replace(/-|:|\.\d{3}/g, '');
}

export function createGoogleCalendarUrl(params: GoogleCalendarEventParams): string {
    const startIso = formatUtcForGoogleCalendar(params.sessionTime);
    const durationMs = (params.durationHours || 3.5) * 60 * 60 * 1000;
    const endIso = formatUtcForGoogleCalendar(params.sessionTime + durationMs);

    const prefix = params.organizerName ? `[${params.organizerName}]` : '[RPG Lodge]';
    const eventTitle = params.sessionNumber
        ? `${prefix} ${params.title} - Session #${params.sessionNumber}`
        : `${prefix} ${params.title}`;

    let location = '';
    if (params.online) {
        location = params.onlinePlatform ? `Online - ${params.onlinePlatform}` : 'Online';
    } else {
        location = params.addressGmapsFormatted || params.addressGmapsUrl || '';
    }

    const detailsLines: string[] = [];

    if (params.title) {
        detailsLines.push(`Adventure: ${params.title}`);
    }
    if (params.sessionNumber) {
        detailsLines.push(`Session: #${params.sessionNumber}`);
    }
    if (params.systemTitle) {
        detailsLines.push(`System: ${params.systemTitle}`);
    }
    if (params.gmName) {
        detailsLines.push(`Game Master: ${params.gmName}`);
    }
    if (params.organizerName) {
        detailsLines.push(`Organizer: ${params.organizerName}`);
    }

    detailsLines.push('');

    if (params.online) {
        detailsLines.push(`Platform: ${params.onlinePlatform || 'Online'}`);
    } else {
        if (params.addressGmapsFormatted) {
            detailsLines.push(`Location: ${params.addressGmapsFormatted}`);
        }
        if (params.addressGmapsUrl) {
            detailsLines.push(`Directions: ${params.addressGmapsUrl}`);
        }
        if (params.accessInfo) {
            detailsLines.push(`Access Info: ${params.accessInfo}`);
        }
    }

    if (params.invitationId) {
        const origin = typeof window !== 'undefined' && window.location ? window.location.origin : 'https://reservations.therpglodge.com';
        detailsLines.push('');
        detailsLines.push(`Adventure Link: ${origin}/invitations/${params.invitationId}`);
    }

    const details = detailsLines.join('\n');

    return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(eventTitle)}&dates=${startIso}/${endIso}&details=${encodeURIComponent(details)}&location=${encodeURIComponent(location)}`;
}
